import { render } from "./DynamicDataView.vue?vue&type=template&id=690f0526&ts=true"
import script from "./DynamicDataView.vue?vue&type=script&lang=ts"
export * from "./DynamicDataView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicDataView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "690f0526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('690f0526', __exports__)) {
    api.reload('690f0526', __exports__)
  }
  
  module.hot.accept("./DynamicDataView.vue?vue&type=template&id=690f0526&ts=true", () => {
    api.rerender('690f0526', render)
  })

}


export default __exports__